export default "__VITE_ASSET__DnfhX$Dq__"